module.exports = __webpack_public_path__ + "static/robe_of_useful_items-c52fe73008bb75c07cd13fc33171b442.jpeg";